import * as React from "react";
import { forwardRef } from "react";
const SvgIconLock = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, viewBox: "0 0 18 18", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M9.001 0a4.866 4.866 0 0 0-4.846 4.846v2.077H2.078V18h13.846V6.923h-2.077V4.846A4.866 4.866 0 0 0 9.001 0m0 1.385a3.47 3.47 0 0 1 3.462 3.462v2.076H5.54V4.846a3.47 3.47 0 0 1 3.461-3.461M3.463 8.308H14.54v8.308H3.463z" }));
const ForwardRef = forwardRef(SvgIconLock);
export { ForwardRef as ReactComponent };
